var React = require('react');

function CartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#025A4D","d":"M1.273 0C.57 0 0 .59 0 1.317s.57 1.317 1.273 1.317h2.684l.457 4.102.006.05 1.958 13.17c.096.643.63 1.117 1.258 1.117h16.546c.607 0 1.129-.443 1.248-1.059l2.545-13.17a1.35 1.35 0 0 0-.264-1.094 1.256 1.256 0 0 0-.984-.482H6.813l-.458-4.102C6.281.502 5.737 0 5.091 0H1.273Zm7 25.024c0-1.09.854-1.975 1.909-1.975h.012c1.055 0 1.91.884 1.91 1.975 0 1.091-.855 1.976-1.91 1.976h-.012c-1.055 0-1.91-.884-1.91-1.976Zm12.091-1.975c-1.055 0-1.91.884-1.91 1.975 0 1.091.855 1.976 1.91 1.976h.012c1.055 0 1.91-.884 1.91-1.976 0-1.09-.855-1.975-1.91-1.975h-.012Z"}));
}

CartInline.defaultProps = {"width":"28","height":"27","fill":"none","viewBox":"0 0 28 27"};

module.exports = CartInline;

CartInline.default = CartInline;
